/* House of Comfort — theme scripts (no dependencies) */
(function () {
  'use strict';

  var HOC = window.HOC || {};

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Math.round(Number(cents) || 0);
    format = format || HOC.moneyFormat || '{{amount}}';
    function delimit(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return delimit(cents, 2);
        case 'amount_no_decimals': return delimit(cents, 0);
        case 'amount_with_comma_separator': return delimit(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delimit(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delimit(cents, 2, "'", '.');
        case 'amount_with_space_separator': return delimit(cents, 2, ' ', ',');
        default: return delimit(cents, 2);
      }
    });
  }
  HOC.formatMoney = formatMoney;

  /* ---------- Header ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile menu ---------- */
  var menu = document.querySelector('[data-mobile-menu]');
  document.addEventListener('click', function (e) {
    if (!menu) return;
    if (e.target.closest('[data-menu-open]')) {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    if (e.target.closest('[data-menu-close]')) {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  });

  /* ---------- Reveal on scroll ---------- */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-revealed'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-revealed'); });
  }

  /* ---------- Modals ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-modal-open]');
    if (opener) {
      var m = document.getElementById(opener.getAttribute('data-modal-open'));
      if (m) { m.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    }
    if (e.target.closest('[data-modal-close]') || e.target.classList.contains('modal')) {
      var open = document.querySelector('.modal.is-open');
      if (open) { open.classList.remove('is-open'); document.body.style.overflow = ''; }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.modal.is-open').forEach(function (m) { m.classList.remove('is-open'); });
    closeDrawer();
    if (menu) menu.classList.remove('is-open');
    document.body.style.overflow = '';
  });

  /* ---------- Cart drawer ---------- */
  function getDrawer() { return document.querySelector('[data-cart-drawer]'); }

  function openDrawer() {
    var d = getDrawer();
    if (!d) { window.location.href = HOC.routes.cart_url; return; }
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var d = getDrawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  HOC.openDrawer = openDrawer;

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  function renderDrawer(html) {
    var d = getDrawer();
    if (!d || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer-inner]');
    var current = d.querySelector('[data-cart-drawer-inner]');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    var countEl = doc.querySelector('[data-cart-item-count]');
    if (countEl) updateCount(countEl.getAttribute('data-cart-item-count'));
    if (HOC.initDelivery) HOC.initDelivery(d);
  }

  function refreshDrawer() {
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + '?sections=cart-drawer' : '/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) { renderDrawer(data['cart-drawer']); });
  }
  HOC.refreshDrawer = refreshDrawer;

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && getDrawer()) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
  });

  function changeLine(line, quantity, scope) {
    var wrap = scope.closest('[data-cart-drawer-inner]') || scope.closest('[data-cart-page]');
    if (wrap) wrap.classList.add('is-loading');
    return fetch(HOC.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (scope.closest('[data-cart-page]')) { window.location.reload(); return; }
        if (cart.sections) renderDrawer(cart.sections['cart-drawer']);
        updateCount(cart.item_count);
      })
      .finally(function () { if (wrap) wrap.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (btn) {
      e.preventDefault();
      var item = btn.closest('[data-line]');
      var input = item.querySelector('input[data-qty-input]');
      var next = Math.max(0, parseInt(input.value, 10) + parseInt(btn.getAttribute('data-qty-change'), 10));
      changeLine(parseInt(item.getAttribute('data-line'), 10), next, btn);
    }
    var rm = e.target.closest('[data-remove-line]');
    if (rm) {
      e.preventDefault();
      changeLine(parseInt(rm.closest('[data-line]').getAttribute('data-line'), 10), 0, rm);
    }
  });

  /* ---------- Cart add helper ---------- */
  function addItems(items) {
    return fetch(HOC.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer' })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || HOC.strings.error);
        return data;
      });
    });
  }
  HOC.addItems = addItems;


  /* ---------- Delivery estimate (real clock, working days Mon–Fri) ---------- */
  function zonedNow(tz) {
    var parts = {};
    try {
      new Intl.DateTimeFormat('en-GB', { timeZone: tz || 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    } catch (e) {
      var d = new Date();
      parts = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate(), hour: d.getHours(), minute: d.getMinutes() };
    }
    return { date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)), hour: +parts.hour, minute: +parts.minute };
  }
  function isWorkday(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6; }
  function addWorkdays(d, n) {
    var r = new Date(d.getTime());
    while (n > 0) { r.setUTCDate(r.getUTCDate() + 1); if (isWorkday(r)) n--; }
    return r;
  }
  function fmtDay(d) {
    var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return days[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + months[d.getUTCMonth()];
  }
  function initDelivery(scope) {
    (scope || document).querySelectorAll('[data-delivery-estimate]').forEach(function (el) {
      var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 14;
      var min = parseInt(el.getAttribute('data-min'), 10) || 3;
      var max = Math.max(min, parseInt(el.getAttribute('data-max'), 10) || 6);
      var now = zonedNow(el.getAttribute('data-tz'));
      var beforeCutoff = isWorkday(now.date) && now.hour < cutoff;
      var dispatch = beforeCutoff ? now.date : addWorkdays(now.date, 1);
      var text = (beforeCutoff ? el.getAttribute('data-template-before') : el.getAttribute('data-template-after')) || '';
      var left = (cutoff * 60) - (now.hour * 60 + now.minute);
      var time = Math.floor(left / 60) + 'h ' + (left % 60) + 'm';
      text = text.replace('[time]', time).replace('[from]', fmtDay(addWorkdays(dispatch, min))).replace('[to]', fmtDay(addWorkdays(dispatch, max)));
      var t = el.querySelector('[data-delivery-text]');
      if (t) {
        t.innerHTML = '';
        var bits = text.split(time);
        t.appendChild(document.createTextNode(bits[0]));
        if (bits.length > 1) {
          var strong = document.createElement('strong'); strong.textContent = time; t.appendChild(strong);
          t.appendChild(document.createTextNode(bits.slice(1).join(time)));
        }
      }
      el.hidden = false;
    });
  }
  HOC.initDelivery = initDelivery;
  initDelivery();
  setInterval(function () { initDelivery(); }, 60000);

  /* ---------- Cart cross-sell ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    var box = btn.closest('[data-upsell]');
    var sel = box.querySelector('[data-upsell-variant]');
    if (!sel.value) { sel.classList.add('is-invalid'); sel.focus(); return; }
    btn.setAttribute('aria-disabled', 'true');
    box.classList.add('is-loading');
    addItems([{ id: parseInt(sel.value, 10), quantity: 1 }])
      .then(function (data) { if (data.sections) renderDrawer(data.sections['cart-drawer']); else return refreshDrawer(); })
      .catch(function () { box.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); });
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-upsell-variant]')) e.target.classList.remove('is-invalid');
  });

  /* ---------- Product form with pack picker ---------- */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = root.querySelector('[data-product-form]');
    var button = root.querySelector('[data-add-button]');
    var buttonLabel = root.querySelector('[data-add-label]');
    var errorEl = root.querySelector('[data-product-error]');
    var savingsEl = root.querySelector('[data-savings]');
    var priceEl = root.querySelector('[data-main-price]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var packs = Array.prototype.slice.call(root.querySelectorAll('[data-pack]'));
    var drawerEnabled = root.getAttribute('data-drawer') === 'true';

    // Which option is colour and which is size
    var optionNames = product.options.map(function (o) { return String(o).toLowerCase(); });
    var sizeIdx = optionNames.findIndex(function (n) { return /size|maat|eu|uk/.test(n); });

    function findVariant(values) {
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return values[i] === undefined || values[i] === opt; });
      });
    }

    function rowVariant(row) {
      var values = [];
      row.querySelectorAll('select[data-option-index]').forEach(function (sel) {
        values[parseInt(sel.getAttribute('data-option-index'), 10)] = sel.value;
      });
      if (!product.options.length || (product.variants.length === 1 && !values.length)) return product.variants[0];
      return findVariant(values);
    }

    // Disable sold-out sizes for the colour chosen in the same row
    function syncRowAvailability(row) {
      if (sizeIdx < 0) return;
      var sizeSel = row.querySelector('select[data-option-index="' + sizeIdx + '"]');
      if (!sizeSel) return;
      var others = {};
      row.querySelectorAll('select[data-option-index]').forEach(function (sel) {
        var idx = parseInt(sel.getAttribute('data-option-index'), 10);
        if (idx !== sizeIdx) others[idx] = sel.value;
      });
      Array.prototype.forEach.call(sizeSel.options, function (opt) {
        if (!opt.value) return;
        var vals = Object.assign({}, others);
        vals[sizeIdx] = opt.value;
        var v = product.variants.find(function (variant) {
          return variant.options.every(function (o, i) { return vals[i] === undefined || vals[i] === o; });
        });
        opt.disabled = !v || !v.available;
        opt.textContent = opt.value + (opt.disabled ? ' — ' + HOC.strings.soldOut : '');
      });
      if (sizeSel.selectedOptions[0] && sizeSel.selectedOptions[0].disabled) sizeSel.value = '';
    }

    function activePack() {
      return packs.find(function (p) { return p.querySelector('input[type=radio]').checked; }) || packs[0];
    }

    function packDiscount(pack) { return pack ? (parseFloat(pack.getAttribute('data-discount')) || 0) : 0; }

    // Show only the photos of the chosen colour (pair 1 of the active set)
    var gallery = document.querySelector('[data-gallery]');
    var colourIdx = gallery ? parseInt(gallery.getAttribute('data-colour-index'), 10) : -1;
    var shownColour = null;
    function syncGallery(pack) {
      if (!gallery || colourIdx < 0) return;
      var sel = pack && pack.querySelector('[data-pack-row] select[data-option-index="' + colourIdx + '"]');
      var colour = sel ? sel.value : null;
      if (!colour || colour === shownColour) return;
      var items = gallery.querySelectorAll('[data-media-colour]');
      var hasMatch = Array.prototype.some.call(items, function (it) { return it.getAttribute('data-media-colour') === colour; });
      if (!hasMatch) return;
      shownColour = colour;
      var leadSet = false;
      items.forEach(function (it) {
        var c = it.getAttribute('data-media-colour');
        var show = !c || c === colour;
        it.hidden = !show;
        it.classList.remove('is-lead');
        if (show && !leadSet) { it.classList.add('is-lead'); leadSet = true; }
      });
      var visible = gallery.querySelectorAll('.product__gallery-item:not([hidden])').length;
      gallery.classList.toggle('is-single', visible <= 1);
      gallery.scrollLeft = 0;
    }

    // Swipe / arrows between colours (drives pair 1 of the active set)
    var colourNav = root.querySelector('[data-colour-nav]');
    var galleryWrap = root.querySelector('[data-gallery-wrap]');
    function colourRow() {
      var pack = activePack();
      return pack ? pack.querySelector('[data-pack-row]') : null;
    }
    function colourChoices(row) {
      if (!row) return [];
      var btns = row.querySelectorAll('[data-swatch]');
      if (btns.length) return Array.prototype.map.call(btns, function (b) { return b.getAttribute('data-swatch'); });
      var sel = row.querySelector('select[data-option-index="' + colourIdx + '"]');
      return sel ? Array.prototype.filter.call(sel.options, function (o) { return o.value; }).map(function (o) { return o.value; }) : [];
    }
    function currentColour(row) {
      var sel = row && row.querySelector('select[data-option-index="' + colourIdx + '"]');
      return sel ? sel.value : null;
    }
    function updateColourNav() {
      if (!colourNav) return;
      var row = colourRow();
      var list = colourChoices(row);
      var cur = currentColour(row);
      var i = list.indexOf(cur);
      colourNav.hidden = list.length < 2;
      var name = colourNav.querySelector('[data-colour-nav-name]');
      var count = colourNav.querySelector('[data-colour-nav-count]');
      var dot = colourNav.querySelector('[data-colour-nav-dot]');
      if (name && cur) name.textContent = cur;
      if (count) count.textContent = (i + 1) + '/' + list.length;
      if (dot && row) {
        var btn = row.querySelector('[data-swatch="' + (window.CSS && CSS.escape ? CSS.escape(cur) : cur) + '"]');
        if (btn) dot.style.setProperty('--swatch', btn.style.getPropertyValue('--swatch'));
      }
    }
    function stepColour(dir) {
      var row = colourRow();
      var list = colourChoices(row);
      if (list.length < 2) return;
      var i = list.indexOf(currentColour(row));
      var next = list[(i + dir + list.length) % list.length];
      if (gallery) { gallery.classList.add('is-swapping'); setTimeout(function () { gallery.classList.remove('is-swapping'); }, 260); }
      var btn = row.querySelector('[data-swatch="' + (window.CSS && CSS.escape ? CSS.escape(next) : next) + '"]');
      if (btn) { btn.click(); return; }
      var sel = row.querySelector('select[data-option-index="' + colourIdx + '"]');
      if (sel) { sel.value = next; sel.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    if (colourNav) {
      colourNav.addEventListener('click', function (e) {
        var b = e.target.closest('[data-colour-step]');
        if (b) stepColour(parseInt(b.getAttribute('data-colour-step'), 10));
      });
    }
    if (gallery && colourNav) {
      var sx = 0, sy = 0, sl = 0, maxSl = 0, tracking = false;
      var start = function (x, y) { sx = x; sy = y; sl = gallery.scrollLeft; maxSl = gallery.scrollWidth - gallery.clientWidth; tracking = true; };
      var end = function (x, y) {
        if (!tracking) return;
        tracking = false;
        var dx = x - sx, dy = y - sy;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
        if (dx < 0 && sl >= maxSl - 4) stepColour(1);
        else if (dx > 0 && sl <= 4) stepColour(-1);
      };
      gallery.addEventListener('touchstart', function (e) { var t = e.touches[0]; start(t.clientX, t.clientY); }, { passive: true });
      gallery.addEventListener('touchend', function (e) { var t = e.changedTouches[0]; end(t.clientX, t.clientY); }, { passive: true });
      gallery.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; start(e.clientX, e.clientY); gallery.classList.add('is-dragging'); });
      window.addEventListener('pointerup', function (e) { if (e.pointerType !== 'mouse' || !tracking) return; gallery.classList.remove('is-dragging'); end(e.clientX, e.clientY); });
      gallery.addEventListener('dragstart', function (e) { e.preventDefault(); });
      var wheelAcc = 0, wheelLock = false;
      gallery.addEventListener('wheel', function (e) {
        if (gallery.scrollWidth > gallery.clientWidth + 4) return;
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
        e.preventDefault();
        if (wheelLock) return;
        wheelAcc += e.deltaX;
        if (Math.abs(wheelAcc) > 60) { stepColour(wheelAcc > 0 ? 1 : -1); wheelAcc = 0; wheelLock = true; setTimeout(function () { wheelLock = false; }, 600); }
      }, { passive: false });
      root.addEventListener('keydown', function (e) {
        if (!galleryWrap || !galleryWrap.contains(document.activeElement)) return;
        if (e.key === 'ArrowRight') stepColour(1);
        if (e.key === 'ArrowLeft') stepColour(-1);
      });
    }

    function update() {
      var pack = activePack();
      syncGallery(pack);
      updateColourNav();
      packs.forEach(function (p) {
        var on = p === pack;
        p.classList.toggle('is-active', on);
        p.querySelectorAll('select').forEach(function (s) { s.disabled = !on; });
      });

      // Per-pack prices (based on first-row variant, or default variant)
      packs.forEach(function (p) {
        var qty = parseInt(p.getAttribute('data-qty'), 10) || 1;
        var rows = p.querySelectorAll('[data-pack-row]');
        var base = 0;
        if (rows.length) {
          rows.forEach(function (r) { var v = rowVariant(r) || product.selected; base += v ? v.price : product.price; });
        } else {
          base = (product.selected ? product.selected.price : product.price) * qty;
        }
        var compareBase = 0;
        if (rows.length) {
          rows.forEach(function (r) {
            var v = rowVariant(r) || product.selected;
            compareBase += v && v.compare_at_price > v.price ? v.compare_at_price : (v ? v.price : product.price);
          });
        } else {
          var sv = product.selected;
          compareBase = (sv && sv.compare_at_price > sv.price ? sv.compare_at_price : (sv ? sv.price : product.price)) * qty;
        }
        var total = Math.round(base * (1 - packDiscount(p) / 100));
        p.setAttribute('data-total', total);
        p.setAttribute('data-compare', compareBase);
        var priceOut = p.querySelector('[data-pack-price]');
        var compareOut = p.querySelector('[data-pack-compare]');
        var perOut = p.querySelector('[data-pack-per]');
        if (priceOut) priceOut.textContent = formatMoney(total);
        if (compareOut) {
          compareOut.textContent = compareBase > total ? formatMoney(compareBase) : '';
        }
        if (perOut && qty > 1) perOut.textContent = formatMoney(Math.round(total / qty)) + ' / pair';
      });

      // Validate active pack
      var rows = pack ? pack.querySelectorAll('[data-pack-row]') : [];
      var ready = true;
      var allAvailable = true;
      rows.forEach(function (r) {
        syncRowAvailability(r);
        var v = rowVariant(r);
        var complete = Array.prototype.every.call(r.querySelectorAll('select'), function (s) { return !!s.value; });
        if (!complete || !v) ready = false;
        else if (!v.available) allAvailable = false;
      });
      if (!rows.length && product.selected && !product.selected.available) allAvailable = false;

      var total = pack ? parseInt(pack.getAttribute('data-total'), 10) : product.price;
      var compare = pack ? parseInt(pack.getAttribute('data-compare'), 10) : 0;
      if (priceEl) priceEl.textContent = formatMoney(total);
      if (stickyPrice) stickyPrice.textContent = formatMoney(total);
      if (savingsEl) savingsEl.textContent = compare > total ? savingsEl.getAttribute('data-template').replace('[amount]', formatMoney(compare - total)) : '';

      button.disabled = !allAvailable;
      if (!allAvailable) buttonLabel.textContent = HOC.strings.soldOut;
      else buttonLabel.textContent = HOC.strings.addToCart + ' — ' + formatMoney(total);
      button.setAttribute('data-ready', ready ? 'true' : 'false');
      var stickyLabel = document.querySelector('[data-sticky-label]');
      if (stickyLabel) stickyLabel.textContent = !allAvailable ? HOC.strings.soldOut : stickyLabel.getAttribute(ready ? 'data-add' : 'data-choose');
    }

    // Colour swatches drive the (hidden) colour select of their row
    root.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-swatch]');
      if (!sw) return;
      var row = sw.closest('[data-pack-row]');
      var group = sw.parentElement;
      group.querySelectorAll('[data-swatch]').forEach(function (b) {
        var on = b === sw;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var name = group.querySelector('[data-swatch-name]');
      if (name) name.textContent = sw.getAttribute('data-swatch');
      var sel = group.parentElement.querySelector('select.visually-hidden[data-option-index]');
      if (sel) { sel.value = sw.getAttribute('data-swatch'); sel.dispatchEvent(new Event('change', { bubbles: true })); }
    });

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-pack] input[type=radio], select')) {
        if (errorEl) errorEl.textContent = '';
        update();
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errorEl) errorEl.textContent = '';
      var pack = activePack();
      var rows = pack ? pack.querySelectorAll('[data-pack-row]') : [];
      var items = {};
      var missing = false;
      if (rows.length) {
        rows.forEach(function (r) {
          var v = rowVariant(r);
          var complete = Array.prototype.every.call(r.querySelectorAll('select'), function (s) { return !!s.value; });
          if (!complete || !v) { missing = true; r.querySelectorAll('select').forEach(function (s) { if (!s.value) s.focus(); }); return; }
          items[v.id] = (items[v.id] || 0) + 1;
        });
      } else {
        var qty = pack ? parseInt(pack.getAttribute('data-qty'), 10) || 1 : 1;
        items[product.selected.id] = qty;
      }
      if (missing) { if (errorEl) errorEl.textContent = errorEl.getAttribute('data-missing'); return; }

      var payload = Object.keys(items).map(function (id) {
        var line = { id: parseInt(id, 10), quantity: items[id] };
        if (pack && pack.getAttribute('data-qty') !== '1') line.properties = { _set: pack.getAttribute('data-label') };
        return line;
      });

      button.setAttribute('aria-disabled', 'true');
      var prev = buttonLabel.textContent;
      buttonLabel.textContent = HOC.strings.adding;
      addItems(payload)
        .then(function (data) {
          if (!drawerEnabled || !getDrawer()) { window.location.href = HOC.routes.cart_url; return; }
          if (data.sections) renderDrawer(data.sections['cart-drawer']);
          else return refreshDrawer();
        })
        .then(function () { if (drawerEnabled) openDrawer(); })
        .catch(function (err) { if (errorEl) errorEl.textContent = err.message || HOC.strings.error; })
        .finally(function () {
          button.removeAttribute('aria-disabled');
          buttonLabel.textContent = prev;
          update();
        });
    });

    // Sticky add to cart on mobile
    var sticky = document.querySelector('[data-sticky-atc]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }).observe(button);
      sticky.querySelector('button').addEventListener('click', function () {
        if (button.getAttribute('data-ready') === 'true' && !button.disabled) {
          if (form.requestSubmit) form.requestSubmit(); else button.click();
        } else {
          form.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (errorEl) errorEl.textContent = errorEl.getAttribute('data-missing');
        }
      });
    }

    update();
  }

  document.querySelectorAll('[data-product]').forEach(initProduct);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-product]').forEach(initProduct);
  });

  /* ---------- Collection sort ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-sort]')) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  });

  /* ---------- Localization selectors ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-localization-select]')) e.target.form.submit();
  });

  /* ---------- Welcome popup ---------- */
  (function () {
    var popup = document.querySelector('[data-popup]');
    if (!popup) return;
    var KEY = 'hoc_popup_closed';
    function store(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
    function read() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
    function open() { popup.hidden = false; requestAnimationFrame(function () { popup.classList.add('is-open'); }); }
    function close() {
      popup.classList.remove('is-open');
      store(String(Date.now()));
      setTimeout(function () { popup.hidden = true; }, 350);
    }
    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]')) close();
      var copy = e.target.closest('[data-copy-code]');
      if (copy) {
        var code = copy.getAttribute('data-copy-code');
        var done = function () { copy.textContent = 'Copied'; };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
      }
    });
    popup.querySelector('form') && popup.querySelector('form').addEventListener('submit', function () { store('subscribed'); });
    var form = popup.closest('form');
    if (form) form.addEventListener('submit', function () { store('subscribed'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !popup.hidden) close(); });
    if (popup.classList.contains('is-open')) { store('subscribed'); return; }
    if (window.Shopify && window.Shopify.designMode) return;
    var last = read();
    if (last === 'subscribed') return;
    var days = parseInt(popup.getAttribute('data-days'), 10) || 14;
    if (last && Date.now() - parseInt(last, 10) < days * 864e5) return;
    setTimeout(open, (parseInt(popup.getAttribute('data-delay'), 10) || 8) * 1000);
  })();

  window.HOC = HOC;
})();
